<div class="main-content">
  <ov-suite-hierarchy-tabs [tabs]="tabs"> </ov-suite-hierarchy-tabs>
  <div class="main-container">
    <ov-suite-hierarchy-table [title]="'Completed Loads'"
                              [formClass]="formClass"
                              [hideAddButton]="true"
                              [excludeColumns]="4"
                              [filter]="filter"
                              [orderColumn]="'releaseDate'"
                              [defaultOrderDirection]="'DESC'"
                              [overrideColumnData]="columnData"
                              [hasBulkUpload]="false">
    </ov-suite-hierarchy-table>
  </div>
</div>

<ng-template #invoiceDownloadDialog>
  <ov-suite-invoice-download-dialog
    [selectedLoadId]="selectedLoadId"
    [selectedOrderIds]="selectedOrderIds"
  >
  </ov-suite-invoice-download-dialog>
</ng-template>
